import React from "react";

export type AuthUser = {
  id: string;
  name: string;
  email?: string;
  roles?: string[];
};

export type AuthState = {
  isAuthenticated: boolean;
  user: AuthUser | null;
  loading: boolean;
};

export type AuthActions = {
  login: (user: AuthUser) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
};

export type AuthContextValue = AuthState & AuthActions;

export const AuthContext = React.createContext<AuthContextValue | undefined>(
  undefined
);
